import cx from 'classnames';
import { useIntl, defineMessages } from 'react-intl';
import UniversalLink from '@plone/volto/components/manage/UniversalLink/UniversalLink';
import Image from '@plone/volto/components/theme/Image/Image';

import InFerraraLogo from './in_ferrara_logo.png';
import ComacchioLogo from './comacchio_logo.jpg';

const EsperienzeTabContent = ({ color }) => {
  const intl = useIntl();
  return (
    <div>
      <div className="top-info">
        <div>
          <p>{intl.formatMessage(messages.prenotazioni_esperienze_descr1)}</p>
          <p>{intl.formatMessage(messages.prenotazioni_esperienze_descr2)}</p>
        </div>
        <div className="logo double">
          <Image src={InFerraraLogo} width="150" alt="" loading="lazy" />
          <Image src={ComacchioLogo} width="150" alt="" loading="lazy" />
        </div>
      </div>

      <div className="buttons-container">
        <UniversalLink
          href={`https://booking.inferrara.it/${intl.locale === 'en' ? intl.locale : ''}`}
          className={cx(`${color} ui button`)}
        >
          Ferrara
        </UniversalLink>
        <UniversalLink
          href="https://shop.deltabooking.com/it/visitcomacchio?button="
          className={cx(`${color} ui button`)}
        >
          Comacchio
        </UniversalLink>
      </div>
    </div>
  );
};

export default EsperienzeTabContent;

const messages = defineMessages({
  prenotazioni_esperienze_descr1: {
    id: 'prenotazioni_esperienze_descr1',
    defaultMessage:
      'A Ferrara e Comacchio puoi vivere esperienze indimenticabili!',
  },
  prenotazioni_esperienze_descr2: {
    id: 'prenotazioni_esperienze_descr2',
    defaultMessage:
      'Clicca sulla tua destinazione, scopri le attività disponibili e acquista comodamente online.',
  },
});
